<div class="product-summary border border-2 px-4 py-3 my-2 rounded-4 d-flex justify-content-between align-items-center bg-white"
     *ngIf="product && sale"
     (click)="onProductDetails()"
     (keydown.enter)="onProductDetails()"
     tabindex="0">
    <span class="d-flex h4 mb-0">
        <div class="d-flex flex-column">
            <h6 *ngIf="product.extra_data?.catalog?.extension as extension">
                {{ extension.provider_name }} - {{ extension.product_type}}
            </h6>
            <div class="fw-bold">{{ product.title }}</div>
            <div class="fw-normal">
                {{ product.extra_data?.data | termMileMonth }}
                <ng-container *ngIf="product.extra_data?.data?.deductibles?.[0] as deductible">
                    (Deductible: {{ deductible.description }})
                </ng-container>
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-square-info fs-5 product-info-icon ms-2 text-danger"
               aria-label="Product Details"
               tabindex="0"
            ></i>
        </div>
    </span>

    <div class="mb-0">
        <span class="h3 fw-bold m-0">
            {{
                product.price
                    | calculatePaymentWithSale : sale
                    | currency:'USD':'symbol':'1.2-2'
            }}
        </span>
        <span class="caption m-0" *ngIf="sale.payment_frequency">
            {{ sale.payment_frequency | paymentSuffix }}
        </span>
    </div>
</div>
